import React, { useState, useRef } from 'react';
import { observer } from 'mobx-react';
import { Link, NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';

import { useDataStore } from '../../state/DataStore';
import AppSettingsPopup from 'components/AppSettingsPopup';
import ShortlistIconButton from 'components/ShortlistIconButton';


const TRIPLE_TAP_WINDOW_MS = 500;


const NavBar = observer(() => {
    const dataStore = useDataStore();
    const [isAppSettingsOpen, setIsAppSettingsOpen] = useState(false);
    const tapCountRef = useRef(0);
    const lastTapTimeRef = useRef(0);
    
    const { appPages } = dataStore;
    const { general_settings: { logo, developer_logo } = {} } = dataStore.settings || {};
    
    const handleDeveloperLogoClick = () => {
        const now = Date.now();
        if (now - lastTapTimeRef.current > TRIPLE_TAP_WINDOW_MS) {
            tapCountRef.current = 0;
        }
        tapCountRef.current += 1;
        lastTapTimeRef.current = now;
        
        if (tapCountRef.current >= 3) {
            tapCountRef.current = 0;
            setIsAppSettingsOpen(true);
        }
    };
    
    return (
        <Container>
            <LogoLink to="/">
                <img src={logo.url} alt="Logo"/>
            </LogoLink>
            
            <Menu>
                {appPages.map(({ slug, title: { rendered: title } }) => {
                    const isHome = (slug === 'home');
                    
                    return (
                        <MenuLink className="h6" key={slug} to={(isHome) ? '/' : `/${slug}`} exact={isHome}>
                            {title}
                        </MenuLink>
                    );
                })}
                <ShortlistIconButton />
            </Menu>
            
            {developer_logo?.url && (
                <DeveloperLogo onClick={handleDeveloperLogoClick}>
                    <img src={developer_logo.url} alt="Developer Logo"/>
                </DeveloperLogo>
            )}
            
            <AppSettingsPopup
                isOpen={isAppSettingsOpen}
                onClose={() => setIsAppSettingsOpen(false)}
            />
        </Container>
    );
});


export default NavBar;


const Container = styled.div`
    position: relative;
    z-index: 2;
    width: 100%;
    height: 10rem;
    padding: 1.5rem 4rem;
    border-top: 0.2rem solid ${props => props.theme.primary_color_highlight};
    
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    background-color: ${props => props.theme.primary_color};
`;

const LogoLink = styled(Link)`
    display: block;
    height: 100%;
    
    img {
        height: 100%;
        width: auto;
    }
`;

const DeveloperLogo = styled.div`
    img {
        height: 5rem;
        width: auto;
        margin-top: 1rem;
    }
`;

const Menu = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 5rem;
`;

const MenuLink = styled(NavLink)`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: white;
    text-decoration: none;
    position: relative;
    padding: 0.5rem 0;
    line-height: 2;

    &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        height: 0.2rem;

        background: linear-gradient(
            to right, 
            ${props => props.theme.accent2_color}, 
            ${props => props.theme.accent_color}, 
            ${props => props.theme.accent2_color}
        );

        transition: all 0.3s ease;
        opacity: 0;
    }

    &.active,
    &:hover {
        &::after {
            opacity: 1;
        }
    }
    
`;
